import React, { useRef } from 'react';
import { END } from 'redux-saga';
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux';
import dynamic from 'next/dynamic'
import Image from 'next/image';
import Link from 'next/link';
import { createBrowserHistory } from 'history';
import Seo from '../../../components/Seo';
import Close from '../../../components/close'
import { wrapper } from '../../../store'
import Layout from '../../../components/Layout';
import { fetchLegals, fetchProjects2 } from '@/sagas/main'
import { actions as mainActions } from '../../../reducers/main';
import { useEffect, useState } from 'react';

let Gallerya = ({children}) => { return (<div>{children}</div>)}
let Itema = (props) => { return (<div {...props}>{props.children}</div>)} 

const AnimationD = dynamic(() => import('@/components/AnimationD'))


const normalizerQuery = (queryStr) => {
  let res = queryStr.toLowerCase();
  res = htmlEntitiesDecode(res)
  res = res.replace(/á/g, 'a');
  res = res.replace(/é/g, 'e');
  res = res.replace(/í/g, 'i');
  res = res.replace(/ó/g, 'o');
  res = res.replace(/ú/g, 'u');
  return res;
} 
const loadPhotoswipeCss = () => {
    const link1 = document.createElement("link");
    link1.rel = "stylesheet";
    link1.href = "/photoswipe.css";
    document.head.appendChild(link1);
    const link2 = document.createElement("link");
    link2.rel = "stylesheet";
    link2.href = "/default-skin.css";
    document.head.appendChild(link2);
   
};


const Project = ({legals}) => {
  const mounted = useRef();
  const router = useRouter();
  const [photoswipeLoaded, setPhotoswipeLoaded] = useState(false)
  const projectDetails = useSelector(state => state.main.projectDetails);
  const { idProject, name } = router.query;
  
  const currentProject = projectDetails && projectDetails[idProject];
  const currentSeo = useSelector(state => state.main.currentSeo);
  const cameFrom = useSelector(state => state.main.cameFrom);

  useEffect(() => {
    if (!mounted.current) {
      // const myhistory = createBrowserHistory()
      // // listener de anchor
      // myhistory.listen(({ location }) => {
      //   const { hash } = location;
      //   if(!hash) {
      //     try { document.querySelector('.pswp__button.pswp__button--close').click() } catch(err){}
      //   }
      // });
      // do componentDidMount logic
      mounted.current = true;
    } else {
      // do componentDidUpdate logic
      if(photoswipeLoaded) {
        let element = document.querySelector(`#img-${photoswipeLoaded}-clicable`);
        element.click()
      }
    }
  });

  if(!currentProject){
    return null;
  }

  const { nombre, contenido, nameUrl, idProyect } = currentProject;
  let { imagen, tipoproyecto } = currentProject;
  let imagenWidth = imagen && imagen[0] && imagen[0].width;
  let imagenHeight = imagen && imagen[0] && imagen[0].height;

  const fetchDependencies = (idImagen) => {
    loadPhotoswipeCss();
    import('react-photoswipe-gallery').then(({ Gallery, Item}) => {
      Gallerya = Gallery;
      Itema = Item;
      setTimeout(() => {
        setPhotoswipeLoaded(idImagen)
      }, 250)
    })
  }
  return (
    <>
      <Seo
        {...currentSeo}
        imagen={(imagen && imagen[0] && imagen[0].src) ? imagen[0].src:''}
        imagenWidth={imagenWidth}
        imagenHeight={imagenHeight}
        url={`/proyecto/${idProyect}/${nameUrl}`}
      />
      <Layout legals={legals} insideContainer={false} intro={false} currentPathName={`/${tipoproyecto.toLowerCase()}`}>
        <div className="ProjectDetails">
          <div className="infoContainer">
            <div className="IntroProject container regular">
              <AnimationD visible />
              <div className="IntroContent">
                <p className="head bold">PROYECTO</p>
                {nombre && (<h1 className="title bold" dangerouslySetInnerHTML={{__html: nombre}} />)}
                <div className="separator" />
                {contenido && (<div className="content textContainer" dangerouslySetInnerHTML={{__html: contenido}}/>)}
                <Link title="Portada" key="backHome" href={cameFrom || "/"}>
                  <Close />
                </Link>
              </div>
              <AnimationD visible={false} />
            </div>
          </div>
          {!photoswipeLoaded && (
            <div className="Gallery">
                <Gallerya>
                  {imagen && imagen.map((itemImage, index) => {
                    const { srcWebp, idImagen, width, height, thumbWebp } = itemImage;
                    const original = `https://www.vicdesign.es/admin${srcWebp}`;
                    const thumbnail = `https://www.vicdesign.es/admin${thumbWebp}`;

                    return (
                      <div key={idImagen} className="ThumbGap">
                        <Itema
                          original={original}
                          thumbnail={thumbnail}
                          width={width || "1024"}
                          height={height || "768"}
                        >
                          {({ ref, open }) => { 
                            return(
                              <a id={`img-${idImagen}-clicable`} className="invisibleClickable" ref={ref} onClick={open} src={thumbnail} />
                            )}
                          }
                        </Itema>
                        <Image fill unoptimized priority className="thumb" src={thumbnail} alt={`miniatura imagen ${index}`} onClick={() => fetchDependencies(idImagen)} />
                      </div>
                    )
                  })}
                </Gallerya>
            </div>
          )}
          {photoswipeLoaded && (
            <div className="Gallery">
              <Gallerya>
                {imagen && imagen.map((itemImage, index) => {
                  const { srcWebp, idImagen, width, height, thumbWebp } = itemImage;
                  const original = `https://www.vicdesign.es/admin${srcWebp}`;
                  const thumbnail = `https://www.vicdesign.es/admin${thumbWebp}`;
                  
                  return (
                    <div key={idImagen} className="ThumbGap">
                      <Itema
                        original={original}
                        thumbnail={thumbnail}
                        width={width || "1024"}
                        height={height || "768"}
                      >
                        {({ ref, open }) => (
                          <a id={`img-${idImagen}-clicable`} className="invisibleClickable" ref={ref} onClick={open} src={thumbnail} />
                          )}
                      </Itema>
                      <Image fill unoptimized priority className="thumb" src={thumbnail} alt={`miniatura imagen ${index}`} />
                    </div>
                  )
                })}
              </Gallerya>
            </div>
          )}

        </div>
        <style jsx>
          {`
          .ProjectDetails {
            position:relative;
            display:grid;
            width:100%;
            grid-template-columns: repeat(1, 1fr);
            max-width: 100%;
            grid-gap: 0px;
            margin-top:2rem;
          }
          .ProjectDetails .infoContainer {
            padding:0px var(--padding-container);
            position:relative;
            text-align:center;
          }
          .ProjectDetails .infoContainer .IntroProject {
            display:flex;
            position:relative;
            flex-direction:row;
            justify-content:space-between;
            align-items: flex-start;
            width: 100%;
            overflow:visible;
          }
          .ProjectDetails .infoContainer .IntroProject .IntroContent {
            width:100%;
          }
          .ProjectDetails .infoContainer .IntroProject .IntroContent .separator {
            display:block;
            margin:1.5rem auto;
            width:2.5rem;
            height:1px;
            background-color:black;
          }
          .ProjectDetails .infoContainer .IntroProject .IntroContent .head{
            font-size:0.9rem;
            margin-bottom:0.5rem;
          }
          .ProjectDetails .infoContainer .IntroProject .IntroContent .title{
            text-transform: uppercase;
            font-size:1.5rem;
          }
          .ProjectDetails .infoContainer .IntroProject .IntroContent .content{
            font-size:0.9rem;
            padding:1rem;
            text-align:justify;
          }


          .ProjectDetails .Gallery {
            padding:0px;
            margin:2rem 0px 7rem 0px;
            font-size:0px;
          }

          .ProjectDetails .Gallery .ThumbGap{
            position:relative;
            aspect-ratio: var(--picture-aspect-ratio);
            width:100%;
            padding:0px;
            margin:0px;
            font-size:0px;
            display:inline-block;
            cursor:pointer;
          }

          .ProjectDetails .Gallery .ThumbGap .invisibleClickable{
            position:absolute;
            top:0px;
            left:0px;
            display:block;
            width:100%;
            height:100%;
            z-index:1;
          }
          @media screen and (max-width:700px) {
            .ProjectDetails .infoContainer .IntroProject {
              padding-top:3rem;
            }
          }

          @media screen and (min-width:600px) {
            .ProjectDetails .Gallery {
              grid-template-columns: repeat(1, 1fr);
            }
            .ProjectDetails .Gallery .ThumbGap {
              width:50%;
            }
          }
          @media screen and (min-width:690px) {
            .ProjectDetails .Gallery {
              grid-template-columns: repeat(2, 1fr);
            }
            .ProjectDetails .Gallery .ThumbGap {
              width:50%;
            }
          }
          @media screen and (min-width:750px) {
            .ProjectDetails .Gallery {
              grid-template-columns: repeat(3, 1fr);
            }
            .ProjectDetails .Gallery .ThumbGap {
                width:33.33%;
              }
          }
          @media screen and (min-width:1665px) {

            .ProjectDetails .Gallery{
              grid-template-columns: repeat(4, 1fr);
            }
            .ProjectDetails .Gallery .ThumbGap {
              width:25%;
            }
          }
          `}
        </style>
      </Layout>
    </>
  )
}


export const getStaticPaths = async () => {
  let paths = await fetchProjects2();
  paths = paths.map(({idProyect,nameUrl}) => {
    return `/proyecto/${idProyect}/${nameUrl}`;
  })
  return {
    paths,
    fallback: "blocking",
  };
}

export const getStaticProps = wrapper.getStaticProps(async (data) => {
    const {store, params} = data;
    const { idProject } = params;
    store.dispatch(mainActions.getProjectsKind());
    store.dispatch(mainActions.getSingleProject(idProject));
    store.dispatch(mainActions.getCurrentSeo({
      page: null,
      entity: "proyectos",
      idName: "idProyect",
      idValue: idProject,
      matching: {
        title: 'nombre',
        description: 'contenido',
        keywords: 'searcherKeywords',
      }
    }));
    store.dispatch(END)
    await store.sagaTask.toPromise()
    const legals = await fetchLegals();
    return {
      props:{
        legals:legals[0]
      },
      revalidate: 1800
    }
})




export default Project;